module.exports = __webpack_public_path__ + "static/media/shark.76dc954e.png";